import { render } from "./widget_head.vue?vue&type=template&id=ceeb42b8&scoped=true"
import script from "./widget_head.vue?vue&type=script&lang=js"
export * from "./widget_head.vue?vue&type=script&lang=js"

import "./widget_head.vue?vue&type=style&index=0&id=ceeb42b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceeb42b8"]])

export default __exports__